import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { appRoutes } from '../app.routes'
import { AppComponent } from '../main/app.component';
import { BlockUiTemplateComponent } from './utilities/block-ui-template/block-ui-template.component'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material.module';
import { KendoModule } from './kendo.module';
import { BlockUIModule } from 'ng-block-ui'
import { APP_CONFIG, APP_DI_CONFIG } from '../app.config';
import { AuthHttp, AuthConfig } from 'angular2-jwt';
import { Http } from '@angular/http'
import { FormFieldsValidator } from "./services/validators/form-field-validator";

import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/map';
import 'rxjs/Rx';

import 'hammerjs';

import { Adal5Service, Adal5HTTPService } from 'adal-angular5';
import { HttpClient, HttpClientModule } from '@angular/common/http';

// to handle permissions service
import { NgxPermissionsModule } from 'ngx-permissions';
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { ResponseInterceptor, UploadInterceptor } from "./services/http/response-interceptor.service";
import { RequestInterceptor } from "./services/http/request-interceptor.service";
import { ToastrService, ConfirmationDialogComponent, RefreshTokenService, LoginService, TokenBase, AuthGuard, MessageService } from "./index";
import { NavigationHistoryService } from "./services/common/navigation-history.service";

export function getAuthHttp(http: Http) {
    return new AuthHttp(new AuthConfig({
        noJwtError: true,
        tokenGetter: (() => sessionStorage.getItem('id_token') || '{}')
    }), http);
}

@NgModule({
    declarations: [
        AppComponent,
        ConfirmationDialogComponent,
        BlockUiTemplateComponent
    ],
    imports: [
        CommonModule,
        HttpModule,
        FormsModule,
        BrowserAnimationsModule,
        KendoModule,
        MaterialModule,
        BlockUIModule.forRoot({
            template: BlockUiTemplateComponent
        }),
        RouterModule.forRoot(appRoutes), //, { enableTracing: true }
        NgxPermissionsModule.forRoot(),
        HttpClientModule
    ],
    providers: [
        ToastrService,
        RefreshTokenService,
        LoginService,
        NavigationHistoryService,
        TokenBase,
        MessageService,
        FormFieldsValidator,
        AuthGuard,
        {
            provide: AuthHttp,
            useFactory: getAuthHttp,
            deps: [Http]
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RequestInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ResponseInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: UploadInterceptor,
            multi: true
        },
        { provide: APP_CONFIG, useValue: APP_DI_CONFIG },
        Adal5Service,
        { provide: Adal5HTTPService, useFactory: Adal5HTTPService.factory, deps: [HttpClient, Adal5Service] }
    ],
    entryComponents: [ConfirmationDialogComponent, BlockUiTemplateComponent]
})
export class AppModuleShared {
}
